var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFC866"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7626_33886)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(6 6)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7626_33886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6C10.4777 6 6 10.4777 6 16C6 21.5223 10.4777 26 16 26C21.5223 26 26 21.5223 26 16C26 10.4777 21.5223 6 16 6ZM16 24.3036C11.4152 24.3036 7.69643 20.5848 7.69643 16C7.69643 11.4152 11.4152 7.69643 16 7.69643C20.5848 7.69643 24.3036 11.4152 24.3036 16C24.3036 20.5848 20.5848 24.3036 16 24.3036ZM17.0647 15.4821L16.4978 15.3504V12.3527C17.346 12.4688 17.8705 13 17.9598 13.6518C17.971 13.7411 18.0469 13.8058 18.1362 13.8058H19.1384C19.2433 13.8058 19.3259 13.7143 19.317 13.6094C19.1808 12.2188 18.0357 11.3259 16.5067 11.1719V10.442C16.5067 10.3438 16.4263 10.2634 16.3281 10.2634H15.7009C15.6027 10.2634 15.5223 10.3438 15.5223 10.442V11.1786C13.942 11.3326 12.7054 12.2054 12.7054 13.8348C12.7054 15.3438 13.817 16.0714 14.9844 16.3504L15.5357 16.4911V19.6763C14.5491 19.5446 13.9955 19.0179 13.8817 18.308C13.8683 18.2232 13.7924 18.1607 13.7054 18.1607H12.6741C12.5692 18.1607 12.4866 18.25 12.4955 18.3549C12.596 19.5826 13.5268 20.7121 15.5134 20.8571V21.558C15.5134 21.6562 15.5938 21.7366 15.692 21.7366H16.3259C16.4241 21.7366 16.5045 21.6563 16.5045 21.5558L16.5 20.8482C18.2478 20.6942 19.4978 19.7589 19.4978 18.0804C19.4955 16.5313 18.5112 15.8393 17.0647 15.4821ZM15.5335 15.1205C15.4085 15.0848 15.3036 15.0513 15.1987 15.0089C14.4442 14.7366 14.0938 14.2969 14.0938 13.7299C14.0938 12.9196 14.7076 12.4576 15.5335 12.3527V15.1205ZM16.4978 19.683V16.6987C16.567 16.7188 16.6295 16.7344 16.6942 16.7478C17.75 17.0692 18.1049 17.5156 18.1049 18.2009C18.1049 19.0737 17.4487 19.5982 16.4978 19.683Z",
    fill: "#212121"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7626_33886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7626_33886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/Dollar.6375e86997fea56927216e91e049b801.svg";
export { ForwardRef as ReactComponent };